import { useCallback, useState } from "react";
import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import UpdateSection from "@/pages/home/components/UpdateSection";
import SeriesSection from "@/pages/home/components/SeriesSection";
import MoviesSection from "@/pages/home/components/MoviesSection";
import BluraySection from "@/pages/home/components/BluraySection";
import PlaylistsSection from "@/pages/home/components/PlaylistsSection";
import LibrarySection from "@/pages/home/components/LibrarySection";
import GuideSection from "@/pages/home/components/GuideSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  const [query, setQuery] = useState("");

  const handleSearch = useCallback((value: string) => {
    setQuery(value);
    window.setTimeout(() => {
      document.getElementById("library")?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 60);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <Header />
      <main>
        <Hero onSearch={handleSearch} />
        <UpdateSection />
        <SeriesSection />
        <MoviesSection />
        <BluraySection />
        <PlaylistsSection />
        <LibrarySection query={query} onQueryChange={setQuery} />
        <GuideSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}